import { useEffect } from "react";
import Lenis from "lenis";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Problem } from "@/components/site/Problem";
import { Solution } from "@/components/site/Solution";
import { Vision } from "@/components/site/Vision";
import { HowItWorks } from "@/components/site/HowItWorks";
import { Impact } from "@/components/site/Impact";
import { BusinessModel } from "@/components/site/BusinessModel";
import { Market } from "@/components/site/Market";
import { FAQ } from "@/components/site/FAQ";
import { DemoForm } from "@/components/site/DemoForm";
import { Footer } from "@/components/site/Footer";
import { Grain } from "@/components/site/Grain";
import { Stars } from "@/components/site/Stars";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  return (
    <div className="relative overflow-x-hidden text-white" data-testid="landing-page">
      <Stars />
      <Grain />
      <Nav />
      <main className="relative z-10">
        <Hero />
        <Problem />
        <Solution />
        <Vision />
        <HowItWorks />
        <Impact />
        <BusinessModel />
        <Market />
        <FAQ />
        <DemoForm />
      </main>
      <Footer />
    </div>
  );
}
